import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ecommercelist() {
  return (
    <section className="ecomm_list p-100 text_whitegreen back_black">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <h2>How Many Types of Ecommerce Apps Can We Develop?</h2>
            <p>
              The Plank app is loaded with several amazing features and
              functions that make it easier for users to understand the exercise
              and perform it correctly. Let’s have a look.
            </p>
            <ul>
              <li>
                <h5>Profile Management</h5>
                <p>
                  The app has a profile management feature from where the users
                  can easily manage and maintain their profiles as per their
                  preferences.
                </p>
              </li>
              <li>
                <h5>Custom Notifications & Alerts</h5>
                <p>
                  The Plank app has a notification and alerts feature as well,
                  where the users get intimidated timely regarding their
                  progress and any other relevant update.
                </p>
              </li>
              <li>
                <h5>Progress Tracking</h5>
                <p>
                  All the users can easily track and maintain their progress on
                  their weekly, monthly, and yearly progress and update their
                  workout charts accordingly.
                </p>
              </li>
              <li>
                <h5>In-App Challenges</h5>
                <p>
                  To make it all interesting and more engaging, there are in-app
                  challenges that let the users challenge their resolve and
                  improve with each passing day.
                </p>
              </li>
              <li>
                <h5>Product Purchase & Payment Processing</h5>
                <p>
                  The Plank has several fitness products listed that can be
                  easily ordered, and all the purchasing and payment processing
                  can be done seamlessly within the app.
                </p>
              </li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-0 my-auto"
          >
            <StaticImage
              src="../../../images/case-studies/pure-plank/ecomm_list.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={780}
              height={707}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercelist;
